import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  fetchConclusionService,
  fetchAllClinics,
  fetchTypeToService
} from '../../../../../main/usecases'
import {
  ClinicsModel,
  ConclusionServiceModel,
  ServiceModelDto,
  TypeToAvaliacaoModel
} from '../../../../../domain/models'

import { goToUrl, maskCpf, dateToday } from '../../../../utils'
import { useModalBox, useOnChangeDetect } from '../../../../contexts'
import { Button, Input, SelectInput, Textarea } from '../../../'
import {
  createNewAssessment,
  updateAssessment
} from '../../../../../main/usecases/services/assesment'
import { FormStyled } from './style'
import moment from 'moment'

type ServiceFormModel = {
  value?: any
  service?: ServiceModelDto | any
  assessment?: any
}

const ServiceForm = ({ value, service, assessment }: ServiceFormModel) => {
  const [typeToService, setTypeToService] = useState<TypeToAvaliacaoModel[]>()
  const [loadClinics, setLoadClinics] = useState<ClinicsModel[]>()
  const [conclusionToService, setConclusionToService] =
    useState<ConclusionServiceModel[]>()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    cpf: maskCpf(value?.cpf),
    name: value?.name || value?.nome,
    dataServico:
      moment(assessment?.dataAvaliacaoPsicologica).format('yyyy-MM-DD') ||
      dateToday,
    dataFinal: moment(assessment?.dataFinal).format('yyyy-MM-DD') || dateToday,
    demanda: assessment?.demanda || '',
    cdTipoAvaliacao: assessment?.tipoAvaliacao?.cdTipoAvaliacao || null,
    cdClinica: assessment?.cdClinica || null,
    cdConclusaoAvaliacao:
      assessment?.conclusaoAvaliacao?.cdConclusaoAvaliacao || null,
    objetivo: assessment?.objetivo || '',
    anotacoes: assessment?.anotacoes || ''
  })
  console.log('---->>>>>>DATA: ', data)

  const history = useHistory()
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const { setRefresh } = useOnChangeDetect()

  const optionsTypeService = useMemo(
    () =>
      typeToService?.map((item) => {
        return { value: item?.cdTipoAvaliacao, label: item?.tipoAvaliacao }
      }),
    [typeToService]
  )

  const optionsClinics = useMemo(
    () =>
      loadClinics
        ?.filter((i) => i.nomeClinica)
        ?.map((item) => {
          return { value: item?.cdClinica, label: item?.nomeClinica }
        }),
    [loadClinics]
  )

  const optionsConclusionService = useMemo(
    () =>
      conclusionToService?.map((item) => {
        return {
          value: item?.cdConclusaoAvaliacao,
          label: item?.conclusaoAvaliacao
        }
      }),
    [conclusionToService]
  )

  useEffect(() => {
    setData((prev: any) => ({
      ...prev,
      cdClinica: optionsClinics && optionsClinics[0]?.value?.toString()
    }))
  }, [optionsClinics])

  useEffect(() => {
    ;(async () => {
      try {
        const responseToTypeService = await fetchTypeToService().load()
        setTypeToService(responseToTypeService)
        const responseToLoadClinics = await fetchAllClinics().load()
        setLoadClinics(responseToLoadClinics)
        const responseToConclusionService =
          await fetchConclusionService().load()
        setConclusionToService(responseToConclusionService)
        // setData((prev) => ({
        //   ...prev,
        //   cdTipoAvaliacao: responseToTypeService.cdTipoAvaliacao
        // }))
        console.log(assessment)
        if (assessment) {
          setData((prev) => ({
            ...prev
            // ...service,
            // cdTipoAvaliacao: service.tipoServico.cdTipoAvaliacao,
            // cdClinica: service?.clinica?.cdClinica,
            // cdConclusaoAvaliacao:
            //   service?.conclusaoAvaliacao?.cdConclusaoAvaliacao
            // demanda: service?.demandaObjetivo,
            // dataServico: service?.dataServico,
          }))
        }
      } catch (error) {
        console.log(error)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessment])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = {
      dataAvaliacaoPsicologica: data.dataServico,
      dataFinal: data.dataFinal,
      demanda: data.demanda,
      tipoAvaliacao: {
        cdTipoAvaliacao: Number(data.cdTipoAvaliacao),
        tipoAvaliacao: typeToService?.find(
          (item) =>
            String(item.cdTipoAvaliacao) === String(data.cdTipoAvaliacao)
        )?.tipoAvaliacao
      },
      ...(data.cdClinica !== undefined && {
        clinica: {
          cdClinica: data.cdClinica,
          nomeClinica: loadClinics?.find(
            (item) => String(item.cdClinica) === String(data.cdClinica)
          )?.nomeClinica
        }
      }),
      ...(data.cdConclusaoAvaliacao &&
      data.cdConclusaoAvaliacao !== '' &&
      data.cdConclusaoAvaliacao !== undefined
        ? {
            conclusaoAvaliacao: service && {
              cdConclusaoAvaliacao: data.cdConclusaoAvaliacao,
              conclusaoAvaliacao: conclusionToService?.find(
                (item) =>
                  String(item.cdConclusaoAvaliacao) ===
                  String(data.cdConclusaoAvaliacao)
              )?.conclusaoAvaliacao
            }
          }
        : { conclusaoAvaliacao: null }),
      objetivo: data.objetivo,
      anotacoes: data.anotacoes,
      servico: {
        cdServico: service?.cdServico,
        cliente: {
          cdCliente: value?.code || value?.cdCliente
        }
      }
    }

    if (assessment) {
      try {
        await updateAssessment(assessment.cdAvaliacaoPsicologica).update(body)
        modalClose(true)
        alert.show('Serviço atualizado com sucesso', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      } catch (error) {
        console.error(error)
        alert.show('Erro ao atualizar um Avaliação psicológica', {
          type: 'error',
          timeout: 4000
        })
      } finally {
        setLoading(false)
      }
    } else {
      try {
        setLoading(true)
        const res = await createNewAssessment().post(body)
        modalClose(true)
        alert.show('Serviço criado com sucesso', {
          type: 'success',
          timeout: 4000
        })
        goToUrl(
          history,
          `/meus-pacientes/${value?.cdCliente}/${service?.cdServico}/avaliacao-psicologica/${res.cdAvaliacaoPsicologica}`
        )
      } catch (error) {
        console.error(error)
        alert.show('Erro ao criar um Avaliação psicológica', {
          type: 'error',
          timeout: 4000
        })
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <FormStyled onSubmit={onSubmit} className="form-assessment">
      <Input
        labelColor="#4F4F4F"
        label="CPF*"
        name="cpf"
        type="text"
        onChange={(e: any) =>
          setData((prev) => ({ ...prev, cpf: e.target.value }))
        }
        value={data.cpf}
        required
        disabled
      />
      <Input
        labelColor="#4F4F4F"
        label="Nome*"
        name="name"
        type="text"
        onChange={(e: any) =>
          setData((prev) => ({ ...prev, name: e.target.value }))
        }
        required
        value={data.name}
        disabled
      />
      <Input
        labelColor="#4F4F4F"
        label="Data inicial*"
        name="initial-date"
        type="date"
        max={'2222-10-29'}
        onChange={(e: any) =>
          setData((prev) => ({ ...prev, dataServico: e.target.value }))
        }
        value={data.dataServico}
      />
      {service && (
        <Input
          labelColor="#4F4F4F"
          label="Data final"
          name="end-date"
          type="date"
          max={'2222-10-29'}
          onChange={(e: any) =>
            setData((prev) => ({ ...prev, dataFinal: e.target.value }))
          }
          value={data.dataFinal}
        />
      )}
      <Input
        labelColor="#4F4F4F"
        label="Demanda*"
        name="demand"
        type="text"
        maxLength={100}
        onChange={(e: any) =>
          setData((prev) => ({ ...prev, demanda: e.target.value }))
        }
        value={data.demanda}
      />
      <SelectInput
        labelColor="#4F4F4F"
        label="Tipo*"
        name="type"
        onChange={(e: any) =>
          setData((prev) => ({ ...prev, cdTipoAvaliacao: e.target.value }))
        }
        options={optionsTypeService}
        required
        value={data.cdTipoAvaliacao || ''}
      />
      {!!optionsClinics?.length && (
        <SelectInput
          labelColor="#4F4F4F"
          label="Clínicas"
          name="clinics"
          hasSelectOption={false}
          onChange={(e: any) =>
            setData((prev) => ({ ...prev, cdClinica: e.target.value }))
          }
          options={optionsClinics}
          defaultValue={data.cdClinica || ''}
        />
      )}
      <Input
        labelColor="#4F4F4F"
        label="Objetivo"
        name="objective"
        type="text"
        onChange={(e: any) =>
          setData((prev) => ({ ...prev, objetivo: e.target.value }))
        }
        value={data.objetivo}
      />
      {optionsConclusionService && (
        <SelectInput
          hasAvaibleDefault
          hasSelectOption={false}
          labelColor="#4F4F4F"
          label="Conclusão"
          name="conclusion"
          onChange={(e: any) =>
            setData((prev) => ({
              ...prev,
              cdConclusaoAvaliacao: e.target.value
            }))
          }
          options={optionsConclusionService}
          value={data.cdConclusaoAvaliacao || ''}
        />
      )}
      <Textarea
        labelColor="#4F4F4F"
        label="Anotações"
        name="annotations"
        onChange={(e: any) =>
          setData((prev) => ({ ...prev, anotacoes: e.target.value }))
        }
        value={data.anotacoes}
      />

      <Button disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</Button>
    </FormStyled>
  )
}

export default ServiceForm
